import './tik_tok_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TikTokMessageContent extends Monitoring.Models.SocialContents.TikTokContent

  hasText: ->
    return !!(@content() && @content().trim().length)

  doNotCutText: ->
    return !@hasText()

  messageType: ->
    return @data().message_type

  conversationId: ->
    return @data().conversation_id

  referencedMessageId: ->
    return @data().referenced_message_id

  imageUrl: ->
    return @data().image?.url

  videoUrl: ->
    return @data().video?.url

  stickerUrl: ->
    return @data().sticker?.url

  sharedPostUrl: ->
    return @data().share_post?.embed_url

  reactionEmojis: ->
    return (reaction.emoji for reaction in (@data().reaction || []))
